import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { fromJS } from 'immutable';
import { CallRecordingSettings } from 'flow/types/CallRecording';
import { callRecordingVaries, monitoringVaries, personalCallRecordingVaries } from './profile-utils';
var recordingSettings = {
  keyName: 'recordCalls',
  headerName: 'settings.call_recording',
  descriptionName: 'settings.record_calls',
  profilesVary: callRecordingVaries
};
var personalRecordingSettings = {
  keyName: 'personalRecordCalls',
  headerName: 'settings.call_recording_personal',
  descriptionName: 'settings.record_personal_calls',
  profilesVary: personalCallRecordingVaries
};
var monitoringSettings = {
  keyName: 'canBeCoMonitored',
  headerName: 'settings.call_monitoring',
  descriptionName: 'settings.allow_call_monitoring',
  profilesVary: monitoringVaries
};
export var getRecordAndMonitoringSettings = function getRecordAndMonitoringSettings(settingType) {
  var settings = {
    business: recordingSettings,
    personal: personalRecordingSettings,
    monitoring: monitoringSettings
  };
  return settings[settingType];
};
export var keysMappedBySettingsType = {
  business: {
    recordCalls: 'recordCalls',
    transcribe: 'autoTranscribe'
  },
  personal: {
    recordCalls: 'personalRecordCalls',
    transcribe: 'personalAutoTranscribe'
  },
  monitoring: {
    recordCalls: null,
    transcribe: null
  }
};
export var getCallRecordingTitle = function getCallRecordingTitle(profile) {
  if (profile !== null && profile !== void 0 && profile.has('autoTranscribe') || profile !== null && profile !== void 0 && profile.has('personalAutoTranscribe')) {
    return 'settings.call_recording_and_transcription';
  }
  return 'settings.call_recording_and_monitoring';
};
export var getCallRecordingValue = function getCallRecordingValue(profile, settingsType) {
  var enableAutoTranscribeWithoutRecordedCall = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var _keysMappedBySettings = keysMappedBySettingsType[settingsType],
    recordCalls = _keysMappedBySettings.recordCalls,
    transcribe = _keysMappedBySettings.transcribe;
  if (profile.get(recordCalls) && profile.get(transcribe)) {
    return CallRecordingSettings.RecordAndAutoTranscribe;
  }
  if (profile.get(recordCalls)) {
    return CallRecordingSettings.RecordCalls;
  }
  if (enableAutoTranscribeWithoutRecordedCall && profile.get(transcribe)) {
    return CallRecordingSettings.AutoTranscribeOnly;
  }
  return CallRecordingSettings.Off;
};
export var getProfileKeysBySettingAndType = function getProfileKeysBySettingAndType(setting, settingsType) {
  if (setting === CallRecordingSettings.RecordAndAutoTranscribe) {
    return _defineProperty(_defineProperty({}, keysMappedBySettingsType[settingsType].recordCalls, true), keysMappedBySettingsType[settingsType].transcribe, true);
  }
  if (setting === CallRecordingSettings.RecordCalls) {
    return _defineProperty(_defineProperty({}, keysMappedBySettingsType[settingsType].recordCalls, true), keysMappedBySettingsType[settingsType].transcribe, false);
  }
  if (setting === CallRecordingSettings.AutoTranscribeOnly) {
    return _defineProperty(_defineProperty({}, keysMappedBySettingsType[settingsType].recordCalls, false), keysMappedBySettingsType[settingsType].transcribe, true);
  }
  return _defineProperty(_defineProperty({}, keysMappedBySettingsType[settingsType].recordCalls, false), keysMappedBySettingsType[settingsType].transcribe, false);
};
export var getUpdatedProfileDTO = function getUpdatedProfileDTO(profile, setting, settingsType) {
  var valueMap = getProfileKeysBySettingAndType(setting, settingsType);
  var profileDTO = {
    key: profile.get('key')
  };
  Object.entries(valueMap).forEach(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
      key = _ref6[0],
      value = _ref6[1];
    if (profile.has(key)) {
      profileDTO = _objectSpread(_objectSpread({}, profileDTO), {}, _defineProperty({}, key, value));
    }
  });
  return fromJS(profileDTO);
};